/**
 * Master Controller
 */

function MasterCtrl($scope, $rootScope, current_user, $state, current_user_info) {
    /**
     * Sidebar Toggle & Cookie Control
     */
    var mobileView = 992;

    current_user.update(current_user_info);

    $scope.getWidth = function() {
        return window.innerWidth;
    };

    $scope.$watch($scope.getWidth, function(newValue, oldValue) {
        $scope.toggle = newValue >= mobileView;

    });

    $scope.toggleSidebar = function() {
        $scope.toggle = !$scope.toggle;
    };

    window.onresize = function() {
        $scope.$apply();
    };
    $rootScope.$current_user = current_user;
}

export default function(app){
    app.controller('MasterCtrl', ['$scope', '$rootScope', 'currentUser', '$state', 'current_user_info', MasterCtrl])
};
